import { FormikValues } from 'formik';

import { AppointmentNotBookedType } from 'types';
import { AppointmentNotBookedTypeLabel } from 'types/data';

export const getInitialValues = (data: FormikValues) => {
  const { internal_notes, technical_issue, case_report_review } = data || {};
  return { internal_notes, technical_issue, case_report_review };
};

export const getAppointmentNotBookedOptions = () => {
  return Object.values(AppointmentNotBookedType).map((value) => ({
    value,
    label: AppointmentNotBookedTypeLabel[value],
  }));
};
